<h1 mat-dialog-title><span *ngIf="editMode">Save</span><span *ngIf="!editMode">Add</span> Crime Report</h1>
<div mat-dialog-content>
  <form [formGroup]="crimeForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col">
          <label class="formLabel" for="AGENCY_NAME">Agency</label>
          <select formControlName="AGENCY_ID">
            <option *ngFor="let item of agencyList" [value]="item.AGENCY_ID">{{item.NAME}}</option>
          </select>
      </div>
      <div class="col">
          <label class="formLabel" for="REPORT_NUMBER">Report #</label>
          <input type="number" formControlName="REPORT_NUMBER">
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="REPORT_DATE">Report Date</label>
           <input [owlDateTime]="REPORT_DATE" [owlDateTimeTrigger]="REPORT_DATE" formControlName="REPORT_DATE">
            <owl-date-time #REPORT_DATE></owl-date-time>
            <!--<input type="datetime-local" formControlName="REPORT_DATE">-->
      </div>
      <div class="col">
          <label class="formLabel" for="LOG_DATE">Log Date</label>
          <!--<input type="date" formControlName="LOG_DATE">-->
          <input [owlDateTime]="LOG_DATE" [owlDateTimeTrigger]="LOG_DATE" formControlName="LOG_DATE">
            <owl-date-time [pickerType]="'calendar'" #LOG_DATE></owl-date-time>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label class="formLabel" for="CRIME_TYPE">Type
          <span *ngIf="editMode">({{this.crime.CRIME_TYPE}})</span>
          <span style="float:right;font-size:12px;"><mat-checkbox formControlName="CRIME_TYPE_UPDATED" color="warn">Report Updated</mat-checkbox></span>
        </label>
          <select formControlName="CRIME_TYPE">
            <option *ngFor="let item of crimeTypeList" [value]="item.DESCRIPTION">{{item.DESCRIPTION}}</option>
          </select>
      </div>
    </div>

    <div class="row" *ngIf="checkType()">
      <div class="col">
        <label class="formLabel" for="CRIME_TYPE_SUB">Subtype
          <span *ngIf="editMode">({{this.crime.CRIME_TYPE_SUB}})</span>
        </label>
          <select formControlName="CRIME_TYPE_SUB">
            <option *ngFor="let item of crimeSubTypeList" [value]="item.VALUE">{{item.VALUE}}</option>
          </select>
      </div>
      <div class="col subtype_text">
            <!--<span style="float:left;font-size:12px;"><mat-checkbox formControlName="CRIME_TYPE_UPDATED" color="warn">Report Updated</mat-checkbox></span>-->
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label class="formLabel">Crime Period</label>
        {{this.crime.CRIME_PERIOD}}
      </div>
    </div>

    <div class="row">
      <div class="col">
          <label class="formLabel" for="CRIME_START">Crime Date Start</label>
          <input [owlDateTime]="CRIME_START" [owlDateTimeTrigger]="CRIME_START" formControlName="CRIME_START">
            <owl-date-time #CRIME_START></owl-date-time>
          <!--<input type="datetime-local" formControlName="CRIME_START">-->
      </div>
      <div class="col">
          <label class="formLabel" for="CRIME_END">Crime Date End</label>
          <input [owlDateTime]="CRIME_END" [owlDateTimeTrigger]="CRIME_END" formControlName="CRIME_END">
            <owl-date-time #CRIME_END></owl-date-time>
          <!--<input type="datetime-local" formControlName="CRIME_END">-->
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="SITE">Site</label>
          <select formControlName="SITECODE">
            <option *ngFor="let x of sites"
            [value]="x.SITECODE">{{x.NAME}}</option>
          </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="BUILDING">Building</label>
          <bats-bldg-lookup formControlName="BUILDING"></bats-bldg-lookup>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="LOCATION">Location</label>
          <input type="text" formControlName="LOCATION">
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" class="formLabel" for="DISPOSITION_ID">Disposition</label>
          <select formControlName="DISPOSITION_ID">
            <option *ngFor="let item of dispList" [value]="item.DISPOSITION_ID">{{item.DESCRIPTION}}</option>
          </select>
      </div>
      <div class="col type_text">
        <span style="float:left;font-size:12px;"> <mat-checkbox formControlName="DISPOSITION_UPDATED" color="warn">Report Updated</mat-checkbox> </span>
      </div>
    </div>
    <div class="row">
      <div class="col">
          <label class="formLabel" for="INCIDENT_COUNT"># Incidents</label>
          <input type="number" formControlName="INCIDENT_COUNT">
      </div>
      <div class="col"></div>
    </div>

    <div mat-dialog-actions>
      <button class="dialog-button btn-success" type="button" *ngIf="editMode" (click)="copyCrime()">Copy</button>
      <button class="dialog-button" type="button" (click)="closeDialog()">Close</button>
      <button class="dialog-button btn-danger" *ngIf="editMode" type="button" (click)="deleteCrime()">Delete</button>
      <button class="dialog-button" type="submit" [disabled]="!crimeForm.valid">Save <span class="btn-danger ml-2 px-3" ngbTooltip="Number of reports that already exist with this report number" *ngIf="numberOfReports > 0">{{numberOfReports}}</span></button>
    </div>
  </form>
</div>
